import React from "react"
import csvIcon from "../../../assets/images/csv-icon.png"

const FileChip = ({ fileName }) => {
  if (!fileName) return null
  return (
    <div className="evidence-file-chip">
      <img
        src={csvIcon}
        alt="csv file"
        className="evidence-file-chip__icon"
      />{" "}
      <span className="evidence-file-chip__name">{fileName}</span>
    </div>
  )
}

export default FileChip
